import React, { FC, useState, useEffect } from 'react';
import {
    Card,
    CardContent,
    Grid,
    CardHeader,
    Typography,
    Divider,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUILoadingLinear, SCUICustomerCardModal } from '../../../../../atomic/atoms';
import Swal from 'sweetalert2';
import { RefundQuery } from '../../../../../services/query';
import { enumConvertRefundToWalletTransactionResult } from '../../../../../types/enums/status';
import Helper from '../../../../../utils/helper';
import { CustomerCommand, ReturnCommand } from '../../../../../services/command';

export const RefundWaitingPayment: FC<{
    currencySymbol?: any;
    refundPlanList: any;
    orderId: any;
    returnId: any;
    returnDatas: any;
    distributedRefundDetails?: any;
    bankAccoutData?: any;
    customerId?: any;
    refundId?: any;
    refundStatus?: any;
    customerFirstName?: any;
    customerLastName?: any;
}> = ({
    currencySymbol,
    refundPlanList,
    orderId,
    returnId,
    returnDatas,
    distributedRefundDetails,
    bankAccoutData,
    customerId,
    refundId,
    refundStatus,
    customerFirstName,
    customerLastName,
}) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [visibleLCWMoney, setVisibleLCWMoney] = useState(false);
    const [visibleDoRefundMethod, setVisibleDoRefundMethod] = useState(false);
    const [creditCardRefundManuel, setCreditCardRefundManuel] = React.useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === 'Otomatik') {
            setCreditCardRefundManuel(false);
        } else {
            setCreditCardRefundManuel(true);
        }
    };
    const [returnedProductItemProcesses, setreturnedProductItemProcesses] = useState<any>([]);
    const onModalOpen = () => setModalOpen(true);
    const onModalClose = () => setModalOpen(false);
    const [modalOpen, setModalOpen] = useState(false);
    useEffect(() => {
        if (returnDatas && returnDatas.productDetailModels) {
            setreturnedProductItemProcesses(
                returnDatas.productDetailModels.map((item: any) => {
                    return {
                        returnItemId: item.returnItemId,
                        productId: item.productId,
                        barcode: item.barcode,
                        quantity: item.piece,
                        restockQuantity: item.restockQuantity === 0 ? item.piece : item.restockQuantity,
                        nonRestockQuantity: item.nonRestockQuantity,
                        rejectedQuantity: item.rejectedQuantity,
                        operatorReturnReasonId: item.operatorReturnReasonId ? item.operatorReturnReasonId : 0,
                        rejectedReason: item.reason,
                        statusId: item.status,
                    };
                })
            );
        }
    }, [returnDatas]);

    useEffect(() => {
        ////////////////////////////////////mobil asisatn için kontrol ettttttt///////////////////////////////////////////////////////////////
        ////////////////////////////////lcwpara hesaba aktarımı kontrol edilecek 3 için /////////////////////////////////////////////
        const filteredRefundPlans = refundPlanList.filter(
            (item: any) => item.refundPlanStatus === 0 && ![1, 7].includes(item.refundPlanMethod)
        );
        if (filteredRefundPlans && filteredRefundPlans.length > 0) {
            setVisibleDoRefundMethod(true);
        }
    }, [refundPlanList]);
    const ConvertRefundToWalletTransaction = async () => {
        setLoading(true);

        let params = {
            CustomerId: customerId,
            RefundId: refundId,
        };

        RefundQuery.ConvertRefundToWalletTransaction(params).then((res: any) => {
            switch (res.data.result) {
                case enumConvertRefundToWalletTransactionResult.Succeeded:
                    Swal.fire('', ' ', 'success');
                    window.location.reload();
                    break;
                case enumConvertRefundToWalletTransactionResult.RefundStatusNotVerified:
                    Swal.fire(t('refund.invalidRefundStatus'), ' ', 'error');
                    break;
                case enumConvertRefundToWalletTransactionResult.RefundReasonNotVerified:
                    Swal.fire(t('refund.refundSourceCustomerRelationError'), ' ', 'error');
                    break;
                case enumConvertRefundToWalletTransactionResult.WalletTransactionNotSucceed:
                    Swal.fire(t('refund.walletTransactionNotSucceed'), ' ', 'error');
                    break;
            }
        });
    };
    const CompleteAndConfirmWalletTransaction = async () => {
        setLoading(true);
        let params: any = {};
        params.orderId = orderId;
        params.returnId = returnId;
        params.customerID = customerId;
        params.storeCode = Helper.getStoreCode();
        params.TryDoRefund = true;
        params.CreditCardRefundManuel = false;
        params.returnedProductItemProcesses = returnedProductItemProcesses;
        params.ConvertRefundToWalletTransaction = true;
        try {
            let res: any = await ReturnCommand.CompleteAndConfirmReturn(params);

            if (res && res.returnedProductProcess.result) {
                window.location.reload();
            } else {
                Swal.fire(' ', ' ', 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    const DoRefund = async () => {
        RefundQuery.DoRefund({
            refundId: refundId,
        }).then((res: any) => {
            setLoading(false);
            if (res) {
                console.info(res);
                window.location.reload();
            }
        });
    };

    const CompleteAndConfirmReturn = async () => {
        setLoading(true);
        let params: any = {};
        params.orderId = orderId;
        params.returnId = returnId;
        params.customerID = customerId;
        params.storeCode = Helper.getStoreCode();
        params.tryDoRefund = true;
        params.creditCardRefundManuel = creditCardRefundManuel;
        params.returnedProductItemProcesses = returnedProductItemProcesses;
        try {
            let res: any = await ReturnCommand.CompleteAndConfirmReturn(params);
            if (res.returnedProductProcess && res.returnedProductProcess.result) {
                window.location.reload();
            } else Swal.fire(' ', ' ', 'error');
        } finally {
            setLoading(false);
        }
    };

    const SendUnmatchedIbanMessage = async () => {
        setVisibleLCWMoney(true);
        CustomerCommand.SendUnmatchedIbanMessage({
            customerId: customerId,
            templateName: 'UnmatchedIbanMessageSection',
            templateParameters: {
                FIRST_NAME: customerFirstName + ' ' + customerLastName,
                AMOUNT: distributedRefundDetails[0].distributedAmount,
            },
        })
            .then(() => {
                Swal.fire(t('customerInformation.sendSMSText'), ' ', 'success');
            })
            .finally(() => {});
    };

    const UpdateWireRefundCustomerChoice = (selectedBankAccount: any) => {
        RefundQuery.UpdateWireRefundCustomerChoice({
            returnId: returnId,
            bankAccountId: selectedBankAccount.bankAccountId,
        }).then(() => {
            Swal.fire(t('general.completed'), ' ', 'success');
            window.location.reload();
        });
    };

    return (
        <Grid container sx={{ paddingLeft: '3rem' }}>
            <SCUICustomerCardModal
                open={modalOpen}
                callFunction={UpdateWireRefundCustomerChoice}
                onClose={onModalClose}
                customerId={customerId}
                buttonText={t('refund.updateCalculation')}
            />
            <SCUILoadingLinear display={loading} />
            <Card style={{ width: '100%' }}>
                <CardHeader
                    title={
                        <Typography noWrap gutterBottom variant="h6" component="h4">
                            <b>{t('refund.paymentInfo')}</b>
                        </Typography>
                    }
                />
                <Divider />
                <CardContent>
                    {refundStatus === 'IncludedToPetition' && returnDatas && (
                        <Grid
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUIButton
                                text={t('refund.closeRefundRecord')}
                                type="primary"
                                sizeType="fixed"
                                size={'l'}
                                buttonType="button"
                                onClick={() => CompleteAndConfirmReturn()}
                            />
                        </Grid>
                    )}
                    {refundStatus === 'IncludedToPetition' && !returnDatas && (
                        <Grid
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUIButton
                                text={t('refund.closeRefundRecord')}
                                type="primary"
                                sizeType="fixed"
                                size={'l'}
                                buttonType="button"
                                onClick={() => DoRefund()}
                            />
                        </Grid>
                    )}
                    {/* dilekçeye dahil edilmedi statsüsünde ise ve cancel ya da complete değilse visibleDoRefundMethod kontrol edilip geliyor */}
                    {refundStatus !== 'IncludedToPetition' &&
                        refundStatus !== 'Canceled' &&
                        refundStatus !== 'Completed' &&
                        visibleDoRefundMethod && (
                            <Grid
                                size={{
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <SCUIButton
                                    text={t('refund.closeRefundRecord')}
                                    type="primary"
                                    sizeType="fixed"
                                    size={'l'}
                                    buttonType="button"
                                    onClick={() => CompleteAndConfirmReturn()}
                                />
                            </Grid>
                        )}
                    {distributedRefundDetails.map(
                        (Item: any, index: number) =>
                            Item.distributedAmount - Item.refundedAmount > 0 && (
                                <React.Fragment key={index}>
                                    <Grid
                                        size={{
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <label>
                                            {' '}
                                            <b>{Helper.GetPaymentNameDesc(Item.refundMethod)} </b>
                                        </label>
                                    </Grid>
                                    {Item.refundMethod === 1 &&
                                        bankAccoutData &&
                                        bankAccoutData.bankAccount &&
                                        bankAccoutData.bankAccount !== null && (
                                            <React.Fragment>
                                                <Grid
                                                    size={{
                                                        md: 12,
                                                        xs: 12,
                                                    }}
                                                >
                                                    <label>
                                                        {' '}
                                                        <b>{t('refund.bankName')}: </b>
                                                        {bankAccoutData.bankAccount.bankName}{' '}
                                                    </label>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        md: 12,
                                                        xs: 12,
                                                    }}
                                                >
                                                    <label>
                                                        <b>{t('refund.accountName')}: </b>
                                                        {bankAccoutData.bankAccount.accountOwner}
                                                    </label>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        md: 12,
                                                        xs: 12,
                                                    }}
                                                >
                                                    <label>
                                                        <b>{t('refund.iban')}: </b>{' '}
                                                        {bankAccoutData.bankAccount.ibanNumber}
                                                    </label>
                                                </Grid>
                                            </React.Fragment>
                                        )}
                                    {Item.refundMethod === 2 && (
                                        <FormControl>
                                            <RadioGroup row value={creditCardRefundManuel} onChange={handleChange}>
                                                <FormControlLabel
                                                    value={'Otomatik'}
                                                    checked={!creditCardRefundManuel}
                                                    control={<Radio />}
                                                    label={t('refund.automatic')}
                                                />
                                                <FormControlLabel
                                                    value={'Manuel'}
                                                    checked={creditCardRefundManuel}
                                                    control={<Radio />}
                                                    label={t('refund.manual')}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    )}
                                    <Grid
                                        size={{
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <label>
                                            <b>{t('general.cost')}: </b>
                                            {Item.distributedAmount - Item.refundedAmount} {currencySymbol}
                                        </label>
                                    </Grid>
                                    <Grid container direction="row" spacing={1} style={{ paddingTop: 5 }}>
                                        {refundStatus === 'IncludedToPetition' &&
                                            (Item.refundMethod === 1 || Item.refundMethod === 3) && (
                                                <React.Fragment>
                                                    <Grid
                                                        size={{
                                                            xl: 3,
                                                            lg: 6,
                                                            md: 12,
                                                            xs: 12,
                                                        }}
                                                    >
                                                        <SCUIButton
                                                            text={t('refund.enterBankInfo')}
                                                            type="primary"
                                                            sizeType="fixed"
                                                            size={'l'}
                                                            buttonType="button"
                                                            onClick={() => onModalOpen()}
                                                        />
                                                    </Grid>
                                                    {visibleLCWMoney && (
                                                        <Grid
                                                            size={{
                                                                xl: 3,
                                                                lg: 3,
                                                                md: 12,
                                                                xs: 12,
                                                            }}
                                                        >
                                                            <SCUIButton
                                                                text={t('lcwMoney.lcwMoneyAssign')}
                                                                type="primary"
                                                                sizeType="fixed"
                                                                size={'l'}
                                                                buttonType="button"
                                                                onClick={() =>
                                                                    returnDatas
                                                                        ? CompleteAndConfirmWalletTransaction()
                                                                        : ConvertRefundToWalletTransaction()
                                                                }
                                                            />{' '}
                                                        </Grid>
                                                    )}

                                                    {!visibleLCWMoney && (
                                                        <Grid
                                                            size={{
                                                                xl: 3,
                                                                lg: 6,
                                                                md: 12,
                                                                xs: 12,
                                                            }}
                                                        >
                                                            <SCUIButton
                                                                text={t('refund.dismatchingIBAN')}
                                                                type="primary"
                                                                sizeType="fixed"
                                                                size={'l'}
                                                                buttonType="button"
                                                                onClick={() => SendUnmatchedIbanMessage()}
                                                            />
                                                        </Grid>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        {refundStatus !== 'IncludedToPetition' && Item.refundMethod === 1 && (
                                            <React.Fragment>
                                                <Grid
                                                    size={{
                                                        xl: 3,
                                                        lg: 6,
                                                        md: 12,
                                                        xs: 12,
                                                    }}
                                                >
                                                    <SCUIButton
                                                        text={t('refund.enterBankInfo')}
                                                        type="primary"
                                                        sizeType="fixed"
                                                        size={'l'}
                                                        buttonType="button"
                                                        onClick={() => onModalOpen()}
                                                    />
                                                </Grid>
                                                {visibleLCWMoney && (
                                                    <Grid
                                                        size={{
                                                            xl: 3,
                                                            lg: 3,
                                                            md: 12,
                                                            xs: 12,
                                                        }}
                                                    >
                                                        <SCUIButton
                                                            text={t('lcwMoney.lcwMoneyAssign')}
                                                            type="primary"
                                                            sizeType="fixed"
                                                            size={'l'}
                                                            buttonType="button"
                                                            onClick={() =>
                                                                returnDatas
                                                                    ? CompleteAndConfirmWalletTransaction()
                                                                    : ConvertRefundToWalletTransaction()
                                                            }
                                                        />{' '}
                                                    </Grid>
                                                )}

                                                {!visibleLCWMoney && (
                                                    <Grid
                                                        size={{
                                                            xl: 3,
                                                            lg: 6,
                                                            md: 12,
                                                            xs: 12,
                                                        }}
                                                    >
                                                        <SCUIButton
                                                            text={t('refund.dismatchingIBAN')}
                                                            type="primary"
                                                            sizeType="fixed"
                                                            size={'l'}
                                                            buttonType="button"
                                                            onClick={() => SendUnmatchedIbanMessage()}
                                                        />
                                                    </Grid>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </Grid>
                                    <Divider sx={{ paddingBottom: 1 }} />
                                    <br />
                                </React.Fragment>
                            )
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
};
